<div class="col-12 widget-wrapper align-self-center" [ngClass]="{'connected': walletAddress}">
  <div class="wallet-box">
    <!--User Details and Round timer -->
    <app-round-user-details [liveCounter]="liveCounter" [raisedInfo]="raisedInfo" [salePrice]="salePrice"></app-round-user-details>
    <!--User Details and Round timer -->

    <!-- Transaction Area -->
    <div class="swapArea" [ngClass]="{ cover: status === SwapStatus.in_progess || status === SwapStatus.confirm_pending || status === SwapStatus.approval_pending }">
      <!-- <p class="text-center mb-3 font-14 dashTitle mt-3" [ngClass]="{ shimmer: !usdRaised || usdRaised <= 0 }" *ngIf="!walletAddress">1 {{ tokenName }} = ${{ salePrice }}</p> -->

      <div class="mt-4 d-flex flex-column align-items-center justify-content-center gap-3">

        <button class="btn btn-primary-outline w-50 px-2" (click)="claimToken()" *ngIf="walletAddress">
          <span>{{ 'widget.claim_token' | translate }}</span>
        </button>

        <button class="btn btn-secondary height-48 primary-shadow text-white w-75" (click)="connectModal('Widget-Crypto')" *ngIf="!walletAddress">
          <span>{{ 'misc.connect_wallet' | translate }}</span>
        </button>

        <!--- dont have wallet-->
        <div class="mb-3 w-100 d-flex justify-content-center align-items-center cursor-pointer" (click)="openBestWallet()" *ngIf="!walletAddress">
          <span class="d-inline-block text-white d-flex justify-content-center font-14 fw-light">{{
            'widget.no_wallet_click_here' | translate }}</span>
        </div>

      </div>

      <div class="mt-3">
        <p class="font-12 text-center mb-0 d-flex align-items-center justify-content-center">
          <span class="me-2 text-white">{{ 'widget.powered_by' | translate }}</span>
          <a href="https://web3paymentsolutions.io" target="_blank">
            <img src="/assets/images/svg-icons/W3P_White.svg" alt="web3paymentsolutions Logo" loading="eager" class="poweredByIcon text-tertiary" />
          </a>
        </p>
      </div>
    </div>
    <!-- Transaction Area -->
  </div>
</div>